import React, { useEffect, useState } from "react";
import { Axios } from "../../App";
import EventCard from "../../components/EventCard/EventCard";

const EventManager = () => {
  const [events, setEvents] = useState([]);

  const getAllEvents = () => {
    return Axios.get("events/getAll.php").then(({ data }) => {
      setEvents(data);
    });
  };

  useEffect(() => {
    const getQueries = async () => {
      await getAllEvents();
    };

    getQueries();
  }, []);

  if (!events?.length) return <p>Nincsenek események...</p>;

  return (
    <section>
      {events.map(({ id, name }) => {
        return <EventCard key={id} eventID={id} eventName={name} />;
      })}
    </section>
  );
};

export default React.memo(EventManager);
